// taken from https://stackoverflow.com/a/44353026/379279
import * as Turbo from "@hotwired/turbo";
import { splitWithoutEmptyStrings } from "./helpers";

class ReloadPageData {
    constructor(
        scrollPosition: [number, number],
        activeTabIds: string[]
    ) {
        this.scrollPosition = scrollPosition;
        this.activeTabIds = activeTabIds;
    }

    public scrollPosition: [number, number];
    public activeTabIds: string[];
}

export function onTurboLoad(handler) {
    $(document).on("turbo:load", handler);
}

export function onTurboBeforeCache(handler) {
    document.addEventListener("turbo:before-cache", handler);
}

export function onTurboPageLoad(pageId: string, handler: () => void) {
    onTurboLoad(() => {
        const currentPageId = $(document.body).attr('data-page-id');
        if (currentPageId !== pageId) return;

        handler();
    });
}

function onTurboBeforeVisit(handler) {
    $(document).on("turbo:before-visit", handler);
}

function getPageUrlAndTitle(): string {
    return `${splitWithoutEmptyStrings(window.location.href, "?")[0]}_${document.title}`;
}

const scrollPositionAndActiveTabsByPageUrlAndTitle = new Map();

function savePageScrollPositionAndActiveTabIds() {
    const pageUrlAndTitle = getPageUrlAndTitle();

    const scrollPosition: [number, number] = [window.scrollX, window.scrollY];
    const activeTabIds = $(".nav-tabs a.nav-link.active").toArray().map(activeTab => $(activeTab).attr("id") as string);

    if (!scrollPositionAndActiveTabsByPageUrlAndTitle.has(pageUrlAndTitle)) {
        scrollPositionAndActiveTabsByPageUrlAndTitle.set(pageUrlAndTitle, new ReloadPageData(scrollPosition, activeTabIds));
    } else {
        const reloadPageData = scrollPositionAndActiveTabsByPageUrlAndTitle.get(pageUrlAndTitle) as ReloadPageData;
        reloadPageData.scrollPosition = scrollPosition;
        reloadPageData.activeTabIds = activeTabIds;
    }
}

export function initializePageScrollPositionAndActiveTabsSaver() {
    onTurboBeforeVisit(() => {
        savePageScrollPositionAndActiveTabIds();
    });
}

export const reloadWithTurbo = (() => {
    function reload() {
        Turbo.visit(window.location.toString(), { action: "replace" });
    }

    onTurboLoad(() => {
        setTimeout(() => {
            if (window.location.hash) {
                const element = $(window.location.hash);
                if (element.length > 0) {
                    const tabPane = element.closest(".tab-pane");
                    if (tabPane.length === 0) return;

                    const tabePaneId = tabPane.attr("id");
                    const tab = $(`a[href='#${tabePaneId}']`);
                    if (tab.length === 0) return;

                    // @ts-ignore
                    tab.tab("show");
                    tab.on("shown.bs.tab", () => {
                        element[0].scrollIntoView();
                    });
                }
            }
            else {
                const pageUrlAndTitle = getPageUrlAndTitle();
                if (scrollPositionAndActiveTabsByPageUrlAndTitle.has(pageUrlAndTitle)) {
                    const reloadPageData = scrollPositionAndActiveTabsByPageUrlAndTitle.get(pageUrlAndTitle) as ReloadPageData;
                    if (reloadPageData.activeTabIds.length > 0) {
                        reloadPageData.activeTabIds.forEach(activeTabId => {
                            const tab = $(`#${activeTabId}`);
                            if (tab.hasClass("active")) {
                                window.scrollTo.apply(window, reloadPageData.scrollPosition);
                            } else {
                                // @ts-ignore
                                tab.tab("show");
                                tab.on("shown.bs.tab", () => {
                                    window.scrollTo.apply(window, reloadPageData.scrollPosition);
                                });
                            }
                        });
                    } else {
                        window.scrollTo.apply(window, reloadPageData.scrollPosition);
                    }
                }
            }
        });
    });

    return reload;
})();

